import { ORIGIN_STRING } from '@/lib/constants';
import { SocialLogin } from '@/lib/types/sso/login';
import { isEmpty } from '@/lib/helpers/empty';

const ssoLink = (path: string) => `${ORIGIN_STRING}/sso/${path}`
const ssoBarePath = (path: string) => `/sso/${path}`

const ssoProfileLink = ssoLink('profile-link')

const ssoLogoutLink = ssoLink('logout')
const ssoLogoutPath = ssoBarePath('logout')
const ssoResolvePath = ssoBarePath('resolve')
const ssoLoginCompletePath = ssoBarePath('login-complete')
const ssoLoginPath = ssoBarePath('login')

interface LoginLinkParams {
  activation?: boolean,
  social?: SocialLogin,
  forcePrompt?: boolean
}

const ssoLoginLink = ({ activation , social, forcePrompt }: LoginLinkParams) => {
  const searchParams = new URLSearchParams()

  if(activation) {
    searchParams.set('activation', 'true');
  }

  if(social) {
    searchParams.set('social', social);
  }

  if(forcePrompt) {
    searchParams.set('prompt', 'true')
  }

  const params = searchParams.toString()

  if(isEmpty(params)) {
    return ssoLink('login')
  }

  return `${ssoLink('login')}?${params}`
}

const ssoRegisterLink = ({ activation }: { activation: boolean }) => {
  const searchParams = new URLSearchParams()

  if(activation) {
    searchParams.set('activation', 'true');
  }

  const params = searchParams.toString()

  if(isEmpty(params)) {
    return ssoLink('register')
  }

  return `${ssoLink('register')}?${params.toString()}`
}

export {
  ssoProfileLink,
  ssoRegisterLink,
  ssoLoginLink,
  ssoLogoutLink,
  ssoLogoutPath,
  ssoResolvePath,
  ssoLoginCompletePath,
  ssoLoginPath
}
